// secureStorage.ts
import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_ROOT_SECURITY_KEY;
if (!SECRET_KEY) {
  throw new Error("[secureStorage] REACT_APP_ROOT_SECURITY_KEY is not set. All Redux persist state would be encrypted with the key 'undefined'.");
}

// NOTE: redux-persist expects promise-based API and string I/O.
export const secureStorage = {
  getItem: (key: string): Promise<string | null> => {
    try {
      const encrypted = localStorage.getItem(key);
      if (!encrypted) return Promise.resolve(null);

      const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8); // <- must be string
      return Promise.resolve(decrypted);
    } catch (e) {
      console.error("secureStorage.getItem decrypt error:", e);
      return Promise.resolve(null);
    }
  },

  setItem: (key: string, value: string): Promise<void> => {
    try {
      const encrypted = CryptoJS.AES.encrypt(value, SECRET_KEY).toString();
      localStorage.setItem(key, encrypted);
      return Promise.resolve();
    } catch (e) {
      console.error("secureStorage.setItem encrypt error:", e);
      return Promise.resolve();
    }
  },

  removeItem: (key: string): Promise<void> => {
    localStorage.removeItem(key);
    return Promise.resolve();
  },
};
